import * as tslib_1 from "tslib";
import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import { getQuestionCategoryList, getQuestionListForPaper } from "@/api/question";
const i = [
    {
        label: "全部题型",
        value: -1
    },
    {
        label: "单选题",
        value: 0
    },
    {
        label: "多选题",
        value: 1
    },
    {
        label: "判断题",
        value: 3
    },
    {
        label: "填空题",
        value: 4
    },
    {
        label: "问答题",
        value: 2
    },
    // {
    //   label: "不定项选择题",
    //   value: 5
    // },
    {
        label: "材料题",
        value: 6
    }
];
const s = [{
        label: "全部题型",
        value: -2
    }, {
        label: "单选题",
        value: 0
    }, {
        label: "多选题",
        value: 1
    }, {
        label: "判断题",
        value: 3
    }];
let SelectQuestionBox = class SelectQuestionBox extends Vue {
    constructor() {
        super(...arguments);
        this.TYPE_LIST = "classQuizzes" !== this.fromResourse ? i : s;
        this.questionDialog = false;
        this.innerLoading = false;
        this.innerLoadingQuestionLibrary = false;
        this.search_content = "";
        this.copySarchContent = "";
        this.loadingScrollAll = false;
        this.loadingScroll = false;
        this.questionLibraries = [];
        this.questionList = [];
        this.pageIndex = 1;
        this.pageSize = 15;
        this.search_content_queslib = "";
        this.select_value = "classQuizzes" !== this.fromResourse ? -1 : -2;
        this.totalCount = 0;
        this.queslib_id_selected = "";
        this.showLoad = false;
        this.defaultProps = {
            children: "children",
            label: "name"
        };
        this.selectedRows = [];
        this.selectedRowsIdLength = 0;
        this.selectCheck = false;
        this.isIndeterminate = false;
    }
    get choose_page_all_status() {
        let counter = 0;
        for (const t of this.questionList) {
            this.questionsId.indexOf(t.id) != -1 && counter++;
        }
        return (this.fromResourse === 'exam' || this.fromResourse === 'classQuizzes') && counter == this.questionList.length;
    }
    get selectedRowsId() {
        return this.selectedRows.map(e => e.id);
    }
    get currentPageSelectedRows() {
        const e = this.selectedRowsId;
        return this.questionList.filter(t => -1 < e.indexOf(t.id));
    }
    get emptyImage() {
        return require("@/assets/empty.png");
    }
    handleSearchContentQuesLibChange(content) {
        this.tree.filter(content);
    }
    handleSelectValueChange() {
        this.pageIndex = 1;
        this.loadingScrollAll = false;
        this.questionList = [];
    }
    handleSelectedRowsChange() {
        this.selectCheck = this.currentPageSelectedRows.length === this.questionList.length;
        this.isIndeterminate = !this.selectCheck && 0 !== this.currentPageSelectedRows.length;
    }
    created() {
        this.questionDialog = this.choseQuestionDialog;
        if (this.fromResourse === 'exercise') {
            this.selectedRows = this.questions.map(e => {
                e.id = e.bank_question_id;
                return e;
            });
        }
        else {
            this.selectedRows = [...this.questions];
        }
        this.getQuestionLibraries();
        this.chooseQuestionLibrary();
    }
    async getQuestionList() {
        var params = {
            categoryId: this.queslib_id_selected !== '0' ? this.queslib_id_selected : void 0,
            content: this.copySarchContent ? this.copySarchContent : void 0,
            type: this.select_value !== -1 ? this.select_value : void 0,
            pageSize: this.pageSize,
            pageNo: this.pageIndex
        };
        this.innerLoading = true;
        try {
            const res = await getQuestionListForPaper(params);
            const data = res.data.data;
            this.totalCount = Number(data.total);
            this.questionList = data.list || [];
            if (this.currentPageSelectedRows.length > 0) {
                this.$nextTick(() => {
                    const tableEl = this.multipleTable;
                    if (tableEl) {
                        this.currentPageSelectedRows.forEach(t => {
                            tableEl.toggleRowSelection(t, true);
                        });
                    }
                });
            }
            this.selectCheck = this.currentPageSelectedRows.length === this.questionList.length;
            this.isIndeterminate = !this.selectCheck && 0 !== this.currentPageSelectedRows.length;
        }
        catch (_) {
            this.getQuestionLibraries();
        }
        finally {
            this.innerLoading = false;
        }
    }
    async getQuestionLibraries() {
        this.showLoad = true;
        try {
            const res = await getQuestionCategoryList();
            this.questionLibraries = res.data.data;
            this.showLoad = false;
        }
        catch (_) {
        }
    }
    handleQuestionLibraryChange(data, node) {
        this.queslib_id_selected = "所有题目" == node.data.name ? "" : node.data.id;
        this.chooseQuestionLibrary();
    }
    filterNode(value, data) {
        if (!value)
            return true;
        return data.name.indexOf(value) !== -1;
    }
    chooseQuestionLibrary() {
        this.pageIndex = 1;
        this.getQuestionList();
    }
    handleSizeChange(pageSize) {
        this.pageIndex = 1;
        this.pageSize = pageSize;
        this.getQuestionList();
    }
    handleCurrentChange(pageIndex) {
        this.pageIndex = pageIndex;
        this.getQuestionList();
    }
    handleSearchType() {
        this.copySarchContent = this.search_content;
        this.pageIndex = 1;
        this.getQuestionList();
    }
    handleSearchContent() {
        this.pageIndex = 1;
        this.copySarchContent = this.search_content;
        this.getQuestionList();
    }
    handleSelectQuestion(_, row) {
        const hasAddedToPaper = this.questionsId.some(e => e === row.id);
        const index = this.selectedRowsId.findIndex(e => e === row.id);
        const hasSelected = index > -1;
        if ((this.fromResourse === 'exam' || this.fromResourse === 'classQuizzes') && hasAddedToPaper || hasSelected) {
            this.selectedRows.splice(index, 1);
        }
        else {
            this.selectedRows.push(row);
        }
    }
    handleSelectCurrentPage(selection) {
        this.selectCheck = selection.length === this.questionList.length;
        if (this.choose_page_all_status && (this.fromResourse === 'exam' || this.fromResourse === 'classQuizzes'))
            return;
        if (selection.length > 0 && this.selectCheck) {
            const unselectedRows = selection.filter(e => -1 === this.selectedRowsId.indexOf(e.id));
            this.selectedRows = this.selectedRows.concat(unselectedRows);
        }
        else {
            this.currentPageSelectedRows.map(e => e.id).forEach(e => {
                const index = this.selectedRowsId.findIndex(t => t === e);
                this.selectedRows.splice(index, 1);
            });
            this.selectedRows = this.selectedRows.concat(selection);
        }
    }
    toggleSelectAll(checked) {
        if (this.choose_page_all_status && (this.fromResourse === 'exam' || this.fromResourse === 'classQuizzes'))
            return;
        const tableEl = this.multipleTable;
        if (checked) {
            const n = tableEl.selection;
            const unselectedRows = n.filter(e => -1 === this.selectedRowsId.indexOf(e.id));
            this.selectedRows = this.selectedRows.concat(unselectedRows);
        }
        else {
            this.currentPageSelectedRows.map(e => e.id).forEach(e => {
                var index = this.selectedRowsId.findIndex(t => t === e);
                this.selectedRows.splice(index, 1);
            });
        }
        tableEl.toggleAllSelection();
    }
    confirm() {
        const selectedRows = this.selectedRows;
        const selectedRowsId = this.selectedRows.map(e => e.id);
        for (let i = selectedRows.length - 1; 0 <= i; i--) {
            if (this.fromResourse !== 'exercise' || selectedRows[i].bank_question_id) {
                const hasSelected = this.questionsId.indexOf(selectedRows[i].id) !== -1;
                if (this.fromResourse !== 'exam'
                    && this.fromResourse !== 'classQuizzes'
                    || hasSelected) {
                    selectedRows.splice(i, 1);
                    selectedRowsId.splice(i, 1);
                }
            }
            else {
                selectedRows[i].bank_question_id = selectedRows[i].id;
                selectedRows[i].id = '';
            }
            if (selectedRows[i] && !selectedRows[i].optionList) {
                selectedRows[i].optionList = [];
            }
        }
        this.selectedRows = [];
        this.questionDialog = false;
        this.$emit("confirm", selectedRows, this.select_value, selectedRowsId);
    }
    cancel() {
        this.questionDialog = false;
        this.$emit("cancel");
    }
    handleAddQuestion() {
        window.open("/#/data-manager/question");
    }
    checkQuestionSelectable(row) {
        const hasAddedToPaper = this.questionsId.some(t => t === row.id);
        return this.fromResourse !== 'exam' && this.fromResourse !== 'classQuizzes' || !hasAddedToPaper;
    }
};
tslib_1.__decorate([
    Prop({ type: Array, default: () => [] })
], SelectQuestionBox.prototype, "questionsId", void 0);
tslib_1.__decorate([
    Prop({ type: Array, default: () => [] })
], SelectQuestionBox.prototype, "questions", void 0);
tslib_1.__decorate([
    Prop({ type: Boolean, default: false })
], SelectQuestionBox.prototype, "choseQuestionDialog", void 0);
tslib_1.__decorate([
    Prop({ type: String, default: 'exam' })
], SelectQuestionBox.prototype, "fromResourse", void 0);
tslib_1.__decorate([
    Ref()
], SelectQuestionBox.prototype, "multipleTable", void 0);
tslib_1.__decorate([
    Ref()
], SelectQuestionBox.prototype, "tree", void 0);
tslib_1.__decorate([
    Watch('search_content_queslib')
], SelectQuestionBox.prototype, "handleSearchContentQuesLibChange", null);
tslib_1.__decorate([
    Watch('select_value', { deep: true })
], SelectQuestionBox.prototype, "handleSelectValueChange", null);
tslib_1.__decorate([
    Watch('selectedRows')
], SelectQuestionBox.prototype, "handleSelectedRowsChange", null);
SelectQuestionBox = tslib_1.__decorate([
    Component({
        name: 'SelectQuestionBox',
        filters: {
            fixRichText(question) {
                if (!question.simpleContent)
                    // return 0 < question.audio_urls.length ? "[音频] " : "暂无文字描述";
                    return question.content ? "[图片]" : "[音频]";
                // let t = question.simpleContent.replace(/<img(.*?)src=\"(.*?)\"(.*?)>/g, "[图片] ");
                // return (t = (t = (t = t.replace(/<iframe(.*?)class="xiaoe-iframe-audio"(.*?)>/g, "[音频] ")).replace(/<iframe(.*?)class="xiaoe-iframe-video"(.*?)>/g, "[视频] ")).replace(/<(?!img).*?>/g, "")).length,
                //   question.describ.length,
                //   t
                // 后端已经把所有html标签都移除了
                return question.simpleContent;
            },
            disableTooltip(e, t) {
                var n = /[\da-zA-Z]/, o = /[\u4e00-\u9fa5]/;
                let a = 0;
                for (let i = 0; i < e.length; i++)
                    if (!n.test(e[i]) && o.test(e[i]) ? a += 2 : a++,
                        a >= t)
                        return !1;
                return !0;
            },
            formatQuestionType: e => ["单选题", "多选题", "问答题", "判断题", "填空题", "不定项选择题", "材料题"][e] || ""
        }
    })
], SelectQuestionBox);
export default SelectQuestionBox;
